import React from "react";
import LoadingSkeleton from "./LoadingSkeleton";

const Loading = ({ type = "spinner", count = 1, ...props }) => {
  if (type === "spinner") {
    console.log(`Loading spinner on path: ${window.location.pathname}`);
    return <LoadingSkeleton type="circle" count={count} {...props} />;
  } else if (type === "card") {
    console.log(`Loading card skeleton on path: ${window.location.pathname}`);
    return <LoadingSkeleton type="card" count={count} {...props} />;
  } else {
    console.log(`Loading line skeleton on path: ${window.location.pathname}`);
    return <LoadingSkeleton type="line" count={count} {...props} />;
  }
};

export default Loading;